import { render, staticRenderFns } from "./AgingChart.vue?vue&type=template&id=f1226eaa&scoped=true"
import script from "./AgingChart.vue?vue&type=script&lang=ts"
export * from "./AgingChart.vue?vue&type=script&lang=ts"
import style0 from "./AgingChart.vue?vue&type=style&index=0&id=f1226eaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1226eaa",
  null
  
)

export default component.exports